<template>
  <ChoiceModal v-if="modalConfirmar" @confirm="usarBala" @cancel="modalConfirmar = false"></ChoiceModal>
  <div class="star-rating" :style="{ '--star-size': size + 'px' }">
    <button v-for="star in max" :key="star" class="star" :class="{ filled: star <= value }" @click="handleClick(star)">
      <span class="star-icon filled-icon text-yellow-500" v-if="star <= value" v-html="filledStar"></span>
      <span class="star-icon empty-icon" v-else v-html="emptyStar"></span>
    </button>
    <div class="cursor-pointer" @click="() => {
      modalConfirmar = true;
    }" v-if="puedeBaleada">
      <img :class="{
        'animate-pulse': !balaUsada,
        'opacity-50': balaUsada,
        'hidden': ocultarBala,


      }" src="https://www.onlygfx.com/wp-content/uploads/2021/10/bullet-9764.jpg" class="w-6 h-6 rounded-full" />
    </div>
  </div>
</template>

<script setup>
import ChoiceModal from "../ChoiceModal.vue";
import { ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
    default: 0, // Valor inicial del ranking
  },
  max: {
    type: Number,
    required: false,
    default: 5, // Número máximo de estrellas
  },
  size: {
    type: Number,
    required: false,
    default: 24, // Tamaño de las estrellas en px
  },
  puedeBaleada: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);
const balaUsada = ref(false);
const ocultarBala = ref(false);
const modalConfirmar = ref(false);

const usarBala = () => {
  emit("usarBala");
  balaUsada.value = true;
  // Ocultar en 3 segundos
  setTimeout(() => {
    ocultarBala.value = true;
  }, 2000);
};

const value = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    value.value = newVal;
  }
);

const handleClick = (rating) => {
  value.value = rating;
  emit("voto", rating);
};

// SVGs
const filledStar = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
  <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
</svg>`;

const emptyStar = `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round"
    d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
</svg>`;
</script>

<style scoped>
.star-rating {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.star {
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  transition: transform 0.2s;
  display: flex;
}

.star:hover {
  transform: scale(1.2);
}

.filled-icon {
  fill: yellow;
}

.empty-icon {
  stroke: white;
}

.star.filled .filled-icon {
  fill: yellow;
}

.star.filled .empty-icon {
  display: none;
}

/* Destello animado */
.star:active {
  animation: pulse 0.3s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.4);
  }

  100% {
    transform: scale(1);
  }
}
</style>
